import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import Fnc from './library/Functions';
import RegSito from './components/registration/RegSito';
import RegPubb from './components/registration/RegPubb';
import RegEnd from './components/registration/RegEnd';
import Bridge from './components/Bridge';
import reportWebVitals from './reportWebVitals';
import Error from './components/generic/Error';
import EmptyBasket from './components/generic/EmptyBasket';
import NotFound from './components/generic/NotFound';
import ScrollToTop from './components/ScrollToTop';
import {
  Routes,
  Route,
  BrowserRouter
} from "react-router-dom";

ReactDOM.render(
  <React.StrictMode>
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/carrello/err" element={<Error />} />
        <Route path="/carrello/empty" element={<EmptyBasket />} />
        <Route path="/carrello/*" element={<App />} />
        <Route path={Fnc.currEnv().registrationSito} element={<RegSito />} />
        <Route path={Fnc.currEnv().registrationCampagna} element={<RegPubb />} />
        <Route path={Fnc.currEnv().registrationEnd} element={<RegEnd />} />
        <Route path="/carrello/bridge" element={<Bridge />} />
        <Route path="*" element={<NotFound />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
